"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Accessibility_meta_1 = require("./Accessibility.meta");

exports.AccessibilityContext = react_1.createContext({
  accessibilityText: function accessibilityText(key, defaultValue) {
    return key;
  }
});

var Accessibility =
/** @class */
function (_super) {
  __extends(Accessibility, _super);

  function Accessibility() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.categoryKey = Accessibility_meta_1.ACCESSIBILITY_CATEGORY_KEY;
    _this.componentKey = Accessibility_meta_1.ACCESSIBILITY_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(Accessibility.prototype, "accesibilityText", {
    get: function get() {
      var _a = this.props,
          children = _a.children,
          _b = _a.defaultValue,
          defaultValue = _b === void 0 ? '' : _b;

      if (typeof children !== 'string' || !this.context || !this.context.accessibilityText) {
        return children;
      }

      return this.context.accessibilityText(children, defaultValue);
    },
    enumerable: true,
    configurable: true
  });

  Accessibility.prototype.render = function () {
    return react_1.default.createElement(react_1.Fragment, null, this.accesibilityText);
  };

  Accessibility.contextType = exports.AccessibilityContext;
  Accessibility = __decorate([mobx_react_1.observer], Accessibility);
  return Accessibility;
}(shared_1.ComponentBase);

exports.Accessibility = Accessibility;
exports.default = shared_1.InjectedStyledComponent(Accessibility, Accessibility_meta_1.ACCESSIBILITY_CATEGORY_KEY, Accessibility_meta_1.ACCESSIBILITY_COMPONENT_KEY);